import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DashboardHeader from "../dashboard/DashboardHeader/DashboardHeader";
import DashboardHero from "../dashboard/DashboardHero/DashboardHero";
import CollapseBlock from "../dashboard/CollapseBlockLeft/collapseblockleft";
import AmountPicker from "./auxiliary/AmountPicker";
import CollapseBlockRight from "../dashboard/collapseblockright/collapseblockright";
import { PaystackConsumer, usePaystackPayment } from "react-paystack";
import { postRequest } from "../apiRequests/requestApi";
import CustomErrorMsg from "../errorMsg/CustomErrorMsg";
import { generateRandomId } from "../globals/globals";
import { useUser } from "../../utils/hooks";

export default function Deposit() {
  const location = useLocation();
  // Get amount from query param if present
  const queryAmount = (() => {
    const params = new URLSearchParams(location.search);
    const amt = params.get("amount");
    return amt ? parseInt(amt, 10) : null;
  })();
  const [isLeftBlockOpen, setIsLeftBlockOpen] = useState(true);
  const [isRightBlockOpen, setIsRightBlockOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState("both");
  const [value, setValue] = useState(queryAmount || 2000);
  const [apiReqs, setApiReqs] = useState({
    isLoading: false,
    errorMsg: null,
  });

  const { user, setUserDetails } = useUser();

  useEffect(() => {
    if (isLeftBlockOpen && isRightBlockOpen) {
      setBlocksOpen("both");
    }

    if (!isLeftBlockOpen && !isRightBlockOpen) {
      setBlocksOpen("none");
    }

    if (
      (!isLeftBlockOpen && isRightBlockOpen) ||
      (isLeftBlockOpen && !isRightBlockOpen)
    ) {
      setBlocksOpen("one");
    }
  }, [isLeftBlockOpen, isRightBlockOpen]);

  const initiateDeposit = (amount) => {
    setApiReqs({ isLoading: true, errorMsg: null });

    return onDeposit(amount);
  };

  const onDeposit = async (amount) => {
    try {
      setApiReqs({ isLoading: true, errorMsg: null });
      console.log("Initiating deposit for amount:", amount);
      const amountinnaira = amount / 100; // Convert kobo to naira
      // Simulate fetching bank transfer details from backend
      // Replace this with your actual API call if needed
      const showCharge = amountinnaira >= 10000;
      const displayAmount = showCharge ? amountinnaira + 50 : amountinnaira;
      const bankDetails = {
        accountNumber: "6868308433",
        accountName: "SKYBOARD GAMES LIMITED",
        bankName: "Moniepoint MFB",
        amount: displayAmount, // Only for display
      };

      // Show a div with the transfer details
      const depositDiv = document.createElement("div");
      depositDiv.style.position = "fixed";
      depositDiv.style.top = "0";
      depositDiv.style.left = "0";
      depositDiv.style.width = "100vw";
      depositDiv.style.height = "100vh";
      depositDiv.style.background = "rgba(0,0,0,0.7)";
      depositDiv.style.display = "flex";
      depositDiv.style.alignItems = "center";
      depositDiv.style.justifyContent = "center";
      depositDiv.style.zIndex = "9999";

      depositDiv.innerHTML = `
        <div style="background:linear-gradient(135deg,#000 60%,#4ade80 100%); color:#fff; border-radius:20px; padding:36px 24px; max-width:370px; width:100%; box-shadow:0 8px 32px rgba(0,0,0,0.35); font-family:'Poppins',sans-serif; text-align:center; position:relative; border:2px solid #4ade80;">
          <button id="closeDepositDiv" style="position:absolute; color:#fff; top:12px; right:12px; background:rgba(0,0,0,0.08); border:none; font-size:1.7rem; cursor:pointer; border-radius:50%; width:36px; height:36px; display:flex; align-items:center; justify-content:center;">&times;</button>
          <img src="https://th.bing.com/th/id/R.9f3ac48b9a811711607dede999a4dd6e?rik=lk25VYxnCFf5lw&pid=ImgRaw&r=0" alt="Moniepoint Logo" style="height:40px; margin-bottom:16px; background:none; border-radius:8px;" />
          <div style="font-weight:bold; color:#4ade80; margin-bottom:14px; font-size:1.1rem; letter-spacing:1px;">BANK TRANSFER</div>
          <div style="display:flex; align-items:center; justify-content:center; gap:10px; font-size:1.15rem; letter-spacing:1px; margin-bottom:8px; color:#fff; font-weight:500;">
            <span style="font-family:'Fira Mono',monospace; font-size:1.15rem;">${
              bankDetails.accountNumber
            }</span>
            <button id="copyAcctBtn" style="background:linear-gradient(90deg,#4ade80,#6499FF); color:#18122B; border:none; border-radius:6px; padding:4px 14px; font-weight:700; cursor:pointer; font-size:0.98rem; box-shadow:0 2px 8px rgba(76,222,128,0.08); transition:background 0.2s;">COPY</button>
          </div>
          <div style="margin-bottom:6px; color:#fff; font-size:1rem; font-weight:500;">${
            bankDetails.accountName
          }</div>
          <div style="margin-bottom:14px; color:#bfc9d8; font-size:0.98rem;">${
            bankDetails.bankName
          }</div>
          <div style="font-size:1.25rem; font-weight:700; margin-bottom:10px; color:#4ade80;">₦${bankDetails.amount.toLocaleString(
            undefined,
            { minimumFractionDigits: 2 }
          )}</div>
          ${
            showCharge
              ? '<div style="color:#e11d48; font-size:0.97rem; margin-bottom:10px;">₦50 charge included for deposits above ₦10,000</div>'
              : ""
          }
          <button id="transferredBtn" style="background:linear-gradient(90deg,#6499FF,#4ade80); color:#fff; border:none; border-radius:8px; padding:10px 0; width:100%; font-weight:700; font-size:1.08rem; margin-top:10px; box-shadow:0 2px 8px rgba(100,153,255,0.08); cursor:pointer;">I HAVE TRANSFERRED</button>
        </div>
      `;

      document.body.appendChild(depositDiv);

      depositDiv.querySelector("#closeDepositDiv").onclick = () => {
        document.body.removeChild(depositDiv);
      };

      depositDiv.querySelector("#copyAcctBtn").onclick = () => {
        navigator.clipboard.writeText(bankDetails.accountNumber);
        depositDiv.querySelector("#copyAcctBtn").innerText = "COPIED!";
        setTimeout(() => {
          depositDiv.querySelector("#copyAcctBtn").innerText = "COPY";
        }, 1200);
      };

      depositDiv.querySelector("#transferredBtn").onclick = async () => {
        depositDiv.querySelector("#transferredBtn").disabled = true;
        depositDiv.querySelector("#transferredBtn").innerText = "Processing...";
        try {
          const response = await postRequest({
            url: "/payment/fake-deposit",
            data: { amount: amount }, // Only send original amount
          });
          if (!response.success) {
            throw new Error(response.message || "Fake deposit failed");
          }
          document.body.removeChild(depositDiv);
          alert("Deposit request sent!");
        } catch (error) {
          depositDiv.querySelector("#transferredBtn").disabled = false;
          depositDiv.querySelector("#transferredBtn").innerText =
            "I HAVE TRANSFERRED";
          alert(error.message || "Fake deposit failed");
        }
      };

      setApiReqs({ isLoading: false, errorMsg: null });
    } catch (error) {
      setApiReqs({
        isLoading: false,
        errorMsg: error.message || "Failed to process deposit",
      });
    }
  };

  return (
    <div style={{ minHeight: "100vh" }} className="dashboard">
      <DashboardHeader />
      <div className="d-lg-flex d-md-flex d-block mt-lg-4 mt-md-4 mt-4 px-lg-4 px-md-4  align-items-start justify-content-between herogeneral">
        <div className="d-lg-none d-md-none d-flex align-items-center justify-content-between mb-4">
          <div className="col-lg-2">
            <CollapseBlock isSmallScreen={true} />
          </div>
          <div className="col-lg-2">
            <CollapseBlockRight isSmallScreen={true} />
          </div>
        </div>

        <div
          className={`${
            isLeftBlockOpen ? "col-lg-2 col-md-2" : "col-lg-1 col-md-1"
          } d-lg-flex d-md-flex d-none`}
        >
          <CollapseBlock setIsLeftBlockOpen={setIsLeftBlockOpen} />
        </div>

        <div
          className={`${
            blocksOpen === "both"
              ? "col-lg-8 col-md-8"
              : blocksOpen === "one"
              ? "col-lg-9 col-md-9"
              : blocksOpen === "none"
              ? "col-lg-10 col-md-10"
              : ""
          } col-auto px-lg-4 px-md-4 px-0`}
        >
          <div className="space-y-2 rounded-[18px] shadow-lg  pb-8 mb-8  mx-auto">
            <h1 className="m-0 p-0 mb-3 font-bold font-quantico text-3xl text-white">
              Deposit <span className="text-green-400">Money</span>
            </h1>
            <p className="m-0 p-0 mb-6 text-[#bfc9d8] font-light font-poppins">
              Enter Amount
            </p>

            {apiReqs.errorMsg && (
              <div className="mb-5">
                <CustomErrorMsg
                  errorMsg={apiReqs.errorMsg}
                  verticalPadding={true}
                />
              </div>
            )}

            <div className="mx-auto w-full max-w-[400px]">
              <AmountPicker
                loading={apiReqs.isLoading}
                btnTxt="Next"
                subTxt="Deposit money from 1k Upwards"
                btnFunc={initiateDeposit}
                value={value}
                setValue={setValue}
              />
            </div>

            {/* <button
              className="btn btn-success mt-3 w-full text-lg font-semibold py-3 rounded-lg shadow-md disabled:opacity-60"
              disabled={apiReqs.isLoading}
              onClick={async () => {
                setApiReqs({ ...apiReqs, isLoading: true, errorMsg: null });
                try {
                  const response = await postRequest({
                    url: "/payment/fake-deposit",
                    data: { amount: value * 100 },
                  });
                  if (!response.success) {
                    throw new Error(response.message || "Fake deposit failed");
                  }
                  setApiReqs({ ...apiReqs, isLoading: false, errorMsg: null });
                } catch (error) {
                  setApiReqs({ ...apiReqs, isLoading: false, errorMsg: error.message || "Fake deposit failed" });
                }
              }}
            >
              I have paid
            </button> */}
          </div>
        </div>

        <div
          className={`${
            isRightBlockOpen ? "col-lg-2 col-md-2" : "col-lg-1 col-md-1"
          } d-lg-flex d-md-flex d-none align-items-center justify-content-end`}
        >
          <div className="">
            <CollapseBlockRight setIsRightBlockOpen={setIsRightBlockOpen} />
          </div>
        </div>
      </div>
    </div>
  );
}
